import Breadcrumb from '@/components/common/Breadcrumb';

const DonationReportMain = () => {
  return (
    <div>
      <Breadcrumb />
      <div className="card">
        <h1 className="text-2xl font-bold text-admin-text mb-4">献本レポート</h1>
        <p className="text-admin-textLight mb-6">
          献本に関するレポートを作成・管理します。
        </p>
        <div className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded">
          <p className="text-sm">
            この機能は今後のPBIで実装予定です。
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationReportMain;
